import { CardButtonLargue } from '@ferreri/prever-component-lib';

import { Publication } from '../publications/publications.types';
import { PUBLICATIONS_SHOW } from '../routes/constants';
import styled from '@emotion/styled';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { useCurrentCoverPublicationImage } from '@modules/publications/publications.store';
import { formatPromotionValue } from '@utils/formatPromotionValue';
import { useRouter } from 'next/router';

type HomePublicationFeaturedListItemProps = {
  publication: Publication;
};

export const HomePublicationFeaturedListItem = (
  props: HomePublicationFeaturedListItemProps,
) => {
  const { publication } = props;
  const router = useRouter();
  const { data: publicationImage } = useCurrentCoverPublicationImage(
    publication?.id,
    publication?.cover_image_id,
  );
  const image = `${router?.basePath}/assets/image/publication-placeholder.webp`;

  return (
    <LinkWrapper href={PUBLICATIONS_SHOW(publication?.id)}>
      <CardButtonLargueStyled
        key={publication?.id}
        title={formatPromotionValue(publication)}
        description={publication?.name}
        image={publicationImage?.asset_url || image}
      />
    </LinkWrapper>
  );
};

const CardButtonLargueStyled = styled(CardButtonLargue)`
  height: 343px;
`;
